export const faqData = [
  {
    question: "What is ISO certification and why does my business need it?",
    answer:
      "ISO certification confirms that your organization meets internationally recognized standards for quality, safety, environment, or security. It builds customer trust, improves processes, and opens access to global markets and tenders.",
  },
  {
    question: "Which ISO standard is right for my organization?",
    answer:
      "ISO 9001 suits quality-focused businesses, ISO 14001 supports environmental management, and ISO 27001 is ideal for information security. MBA Solutions assesses your industry, goals, and compliance requirements to recommend the best standard.",
  },
  {
    question: "How long does ISO certification usually take?",
    answer:
      "Timelines vary by company size and readiness. Most organizations complete certification in 3 to 6 months after gap analysis, documentation, implementation, internal audits, and final certification audit.",
  },
  {
    question: "Do you provide audit, training, and implementation support?",
    answer:
      "Yes. MBA Solutions offers gap assessments, documentation toolkits, internal audit training, implementation consulting, and pre-certification readiness reviews.",
  },
  {
    question: "How do I get started with MBA Solutions?",
    answer:
      "Contact us via phone, email, or the contact form. We schedule an initial consultation, evaluate your current compliance level, and propose a tailored certification roadmap.",
  },
  {
    question: "Which industries do you serve?",
    answer:
      "We support manufacturing, packaging, export, technology, services, and sustainability-focused organizations across Pakistan and international markets.",
  },
];

export const contactCardsData = [
  { label: "Email Us", value: "atif@mbasolutions.com" },
  { label: "Call Us", value: "+92 301 4900495" },
  { label: "Visit Us", value: "Office # 11-2 B2 Township, Lahore, Pakistan" },
];

export const mapCenter = [31.494, 74.3436];
